import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';

const ReportsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="container-fluid">
        <h1 className="mb-4">Reports</h1>
        <div className="row">
          <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Sales Report</h5>
                <p className="card-text">View sales performance, trends, and customer analysis</p>
                <button className="btn btn-sm btn-primary" onClick={() => navigate('/reports/sales')}>View Report</button>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Stock Report</h5>
                <p className="card-text">View current stock levels and movements</p>
                <button className="btn btn-sm btn-primary" onClick={() => navigate('/stock/reports')}>View Report</button>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Supplier Report</h5>
                <p className="card-text">View supplier performance and metrics</p>
                <button className="btn btn-sm btn-primary">View Report</button>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Order Report</h5>
                <p className="card-text">View purchase and sales order analytics</p>
                <button className="btn btn-sm btn-primary">View Report</button>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Financial Report</h5>
                <p className="card-text">View financial metrics and analysis</p>
                <button className="btn btn-sm btn-primary">View Report</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ReportsPage;
